// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as IconButton from "../actions/IconButton.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function isButtonDisabled(action, currentPage, totalPages) {
  switch (action) {
    case "First":
    case "Prev":
      return currentPage <= 1;
    case "Next":
    case "Last":
      return currentPage >= totalPages;
  }
}
function LegacyPagination$ControlButton(props) {
  let onPress = props.onPress;
  let action = props.action;
  let disabled = isButtonDisabled(action, props.currentPage, props.totalPages);
  let newrecord = {
    ...{
      className: "margin-xxginqi",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:24"
    }
  };
  let tmp;
  switch (action) {
    case "First":
      tmp = "double_arrow_left_light";
      break;
    case "Prev":
      tmp = "arrow_left_light";
      break;
    case "Next":
      tmp = "arrow_right_light";
      break;
    case "Last":
      tmp = "double_arrow_right_light";
      break;
  }
  newrecord.children = JsxRuntime.jsx(IconButton.make, {
    name: tmp,
    marginSize: "small",
    color: disabled ? "#d7d7e0" : "#25243a",
    disabled: disabled,
    onPress: param => onPress(action)
  });
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(LegacyPagination$ControlButton);
function viewStyleFromParams(disabled) {
  return {
    0: {
      className: "display-x78zum5 flexDirection-xdt5ytf height-x1fgtraw justifyContent-xl56j7k marginInline-xckhbgb minWidth-x1264ykn paddingInline-xm9j1uf",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:62"
    },
    1: {
      className: "display-x78zum5 flexDirection-xdt5ytf height-x1fgtraw justifyContent-xl56j7k marginInline-xckhbgb minWidth-x1264ykn paddingInline-xm9j1uf backgroundColor-x1srn7af",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:62; wino-gc:src/resources/navigation/LegacyPagination.res.js:71"
    }
  }[!!disabled << 0];
}
function textStyleFromParams(disabled) {
  return {
    0: {
      className: "color-x1i7sqjx font-xhhohpu textAlign-x2b8uid",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:74"
    },
    1: {
      className: "textAlign-x2b8uid color-xbp64b2 font-x1jwuenu",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:74; wino-gc:src/resources/navigation/LegacyPagination.res.js:79"
    }
  }[!!disabled << 0];
}
function LegacyPagination$PageButton(props) {
  let onPress = props.onPress;
  let action = props.action;
  let disabled = action !== undefined ? isButtonDisabled(action, props.currentPage, props.totalPages) : true;
  let newrecord = {
    ...viewStyleFromParams(disabled)
  };
  let newrecord$1 = {
    ...textStyleFromParams(disabled)
  };
  newrecord.children = JsxRuntime.jsx("span", (newrecord$1.children = props.children, newrecord$1));
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx("div", newrecord),
    disabled: disabled,
    onPress: param => {
      if (action !== undefined) {
        return onPress(action);
      }
    }
  });
}
let make$1 = React.memo(LegacyPagination$PageButton);
function LegacyPagination(props) {
  let onPress = props.onRequestPaginate;
  let totalPages = props.totalPages;
  let currentPage = props.currentPage;
  let newrecord = {
    ...{
      className: "backgroundColor-x17suf5r borderTopColor-x1eit1tb borderTopStyle-x13fuv20 borderTopWidth-x178xt8z alignItems-x6s0dn4 display-x78zum5 flexDirection-x1q0g3np height-x1peatla justifyContent-x1qughib paddingInline-x17qtykl",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:114"
    }
  };
  let newrecord$1 = {
    ...{
      className: "color-x1i7sqjx font-xyeg6z0",
      "data-style-src": "wino-gc:src/resources/navigation/LegacyPagination.res.js:126"
    }
  };
  newrecord.children = [JsxRuntime.jsx("span", (newrecord$1.children = "Page " + (currentPage.toString() + (I18n.t(" of ") + totalPages.toString())), newrecord$1)), JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(make, {
      currentPage: currentPage,
      totalPages: totalPages,
      action: "First",
      onPress: onPress
    }), JsxRuntime.jsx(make, {
      currentPage: currentPage,
      totalPages: totalPages,
      action: "Prev",
      onPress: onPress
    }), JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [currentPage > 1 ? JsxRuntime.jsx(make$1, {
          currentPage: currentPage,
          totalPages: totalPages,
          action: "Prev",
          children: currentPage - 1 | 0,
          onPress: onPress
        }) : null, JsxRuntime.jsx(make$1, {
          currentPage: currentPage,
          totalPages: totalPages,
          children: currentPage,
          onPress: onPress
        }), currentPage < totalPages ? JsxRuntime.jsx(make$1, {
          currentPage: currentPage,
          totalPages: totalPages,
          action: "Next",
          children: currentPage + 1 | 0,
          onPress: onPress
        }) : null]
      }),
      spaceX: "xsmall"
    }), JsxRuntime.jsx(make, {
      currentPage: currentPage,
      totalPages: totalPages,
      action: "Next",
      onPress: onPress
    }), JsxRuntime.jsx(make, {
      currentPage: currentPage,
      totalPages: totalPages,
      action: "Last",
      onPress: onPress
    })]
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let make$2 = React.memo(LegacyPagination);
export { isButtonDisabled, make$2 as make };
/* styles Not a pure module */